import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from "../CredentialLayout";
import { CredentialProps } from "../CredentialProps";

export interface GitHubViewPageProps extends NSARouterMakerResult, CredentialProps { }

class GitHubViewPage extends Component<GitHubViewPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section shows the full details of a GitHub credential, including its name and the personal access token it stores as a secret. You can review its history and tags and copy any field, while the secret value stays protected."
                }}
                pages={{
                    entity: CredentialEntities.git_hub(this.props),
                    view: {}
                }}
            >
                <></>
            </CredentialLayout>
        );
    }
}

export default GitHubViewPage;